import { useTranslation } from 'react-i18next';
import { type FC } from 'react';

import s from './styles.module.scss';

interface CHFRenalStatusProps {}

const CHFRenalStatus: FC<CHFRenalStatusProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={s['chf-wrapper']} data-chf data-sub-status>
      <p className={s['chf-text']}>{t('labels.CHFRenal')}</p>
    </div>
  );
};
export default CHFRenalStatus;
